export default "__VITE_ASSET__BRcEI02k__"